import React from 'react';
import AwardingDetail from '../../Awarding/detail';

const AwardingSupplierDetail = () => (
  <AwardingDetail mode='supplier' listPath='/apps-awarding-supplier/view' />
);

export default AwardingSupplierDetail;
